/**
 * 尺寸适配屏幕,使用在postcss无法处理的地方，如 canvas
 */

const trans = (value, viewportWidth = 375) => (value / (viewportWidth / 100) / 100) * document.body.clientWidth

export function postcssPatch(value) {
  switch (typeof value) {
    case 'number':
      return trans(value)
    case 'string':
      if (value.endsWith('px')) {
        const num = Number(value.slice(0, -2))
        const unit = value.slice(-2)
        return `${trans(num)} ${unit}`
      }
      console.warn('需要以 px 结尾字符串')
      return value
    default:
      return value
  }
}
